import React from 'react';
import PropTypes from 'prop-types';
import OrgaoCentralizadoItem from './OrgaosCentralizadosItem';
import { DataGrid, Grid } from '../index';

const OrgaosCentralizadosControl = (props) => {
  const handleItens = () => {
    const mappedOrgaos = props.orgaosCentralizados;
    const orgaos = [];
    if (mappedOrgaos) {
      mappedOrgaos.forEach((item) => {
        orgaos.push(<OrgaoCentralizadoItem
          orgao={item}
          buscaParticipanteRpps={props.buscaParticipanteRpps}
          // handleSuccessBuscaDadosParticipanteRpps={props.handleSuccessBuscaDadosParticipanteRpps}
          // handleErrorBusca={props.handleErrorBusca}
        />);
      });
    }
    return orgaos;
  };

  return props.orgaosCentralizados.length > 0 ? (
    <DataGrid title="Orgãos Centralizados" icon="ico-doc-book">
      <div className="row">
        <Grid cols="12 12 12 12" style={{ height: '200px', overflowX: 'hidden', overflowY: 'scroll' }}>
          {handleItens()}
        </Grid>
      </div>
    </DataGrid>
  ) : null;
};

OrgaosCentralizadosControl.propTypes = {
  // handleSearchPesquisaCadPrevButton: PropTypes.func.isRequired,
  orgaosCentralizados: PropTypes.arrayOf(PropTypes.shape({
    codigo: PropTypes.string,
    nome: PropTypes.string,
  })).isRequired,
  buscaParticipanteRpps: PropTypes.func.isRequired,
  // handleSuccessBuscaDadosParticipanteRpps: PropTypes.func.isRequired,
  // handleErrorBusca: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

export default OrgaosCentralizadosControl;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/OrgaosCentralizadosControl.jsx